import { render, staticRenderFns } from "./RecordList.vue?vue&type=template&id=615f390c&scoped=true&"
import script from "./RecordList.vue?vue&type=script&lang=js&"
export * from "./RecordList.vue?vue&type=script&lang=js&"
import style0 from "./RecordList.vue?vue&type=style&index=0&id=615f390c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615f390c",
  null
  
)

component.options.__file = "RecordList.vue"
export default component.exports